import React from 'react';
import { Icon } from './Icon.js';
export const IconMenuLeft2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M15.75,15H2.25c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75H15.75c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z", fill: "currentColor" }),
        React.createElement("path", { d: "M15.75,4.5H2.25c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75H15.75c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z", fill: "currentColor" }),
        React.createElement("path", { d: "M9.25,9.75H2.25c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75h7c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconMenuLeft2Fill18.js.map